import { useEffect, useState } from "react"
import moment from "moment";
import { getLocation, getLoctionOpenHours } from "../../services/Location";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { LatLngExpression } from "leaflet";

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export const AllLocations = () => {
    const [allLocations, setAllLocations] = useState<any[]>([]);
    const [allLocationsOpeningHours, setAllLocationsOpeningHours] = useState<any[]>([]);
    const [dataIsLoaded, setDataIsLoaded] = useState<boolean>(false);

    const center: LatLngExpression =
        allLocations.length > 0
            ? [allLocations[0].latitude, allLocations[0].longitude]
            : [0, 0];

    const primaryPin = L.divIcon({
        html: `
              <div style="filter: drop-shadow(0 6px 10px rgba(0,0,0,0.45));">
                <svg width="46" height="46" viewBox="0 0 24 24">
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                    fill="#EA8616"
                  />
                  <circle cx="12" cy="9" r="3" fill="white"/>
                </svg>
              </div>
            `,
        className: "",
        iconSize: [46, 46],
        iconAnchor: [23, 46],
        popupAnchor: [0, -46],
    });

    useEffect(() => {
        const fetchData = async () => {
            setDataIsLoaded(false);

            try {
                const [locations, hours] = await Promise.all([
                    getLocation(),
                    getLoctionOpenHours(),
                ]);

                setAllLocations(locations || []);

                if (!hours || hours.length === 0) {
                    setAllLocationsOpeningHours([]);
                    setDataIsLoaded(true);
                    return;
                }

                const formattedHours = hours
                    .filter(
                        (item: any) =>
                            new Date(item?.startDate) <= new Date() &&
                            new Date(item?.endDate) >= new Date()
                    )
                    .map((item: any) => ({
                        sundayOpenTime: item?.isSundayOpen
                            ? item?.sundayOpenTime
                                ? moment(item?.sundayOpenTime, "HH:mm").format("hh:mm A")
                                : ""
                            : "",
                        sundayCloseTime: item?.isSundayOpen
                            ? item?.sundayCloseTime
                                ? moment(item?.sundayCloseTime, "HH:mm").format("hh:mm A")
                                : ""
                            : "",
                        mondayOpenTime: item?.isMondayOpen
                            ? moment(item?.mondayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        mondayCloseTime: item?.isMondayOpen
                            ? moment(item?.mondayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        tuesdayOpenTime: item?.isTuesdayOpen
                            ? moment(item?.tuesdayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        tuesdayCloseTime: item?.isTuesdayOpen
                            ? moment(item?.tuesdayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        wednesdayOpenTime: item?.isWednesdayOpen
                            ? moment(item?.wednesdayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        wednesdayCloseTime: item?.isWednesdayOpen
                            ? moment(item?.wednesdayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        thursdayOpenTime: item?.isThursdayOpen
                            ? moment(item?.thursdayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        thursdayCloseTime: item?.isThursdayOpen
                            ? moment(item?.thursdayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        fridayOpenTime: item?.isFridayOpen
                            ? moment(item?.fridayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        fridayCloseTime: item?.isFridayOpen
                            ? moment(item?.fridayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        saturdayOpenTime: item?.isSaturdayOpen
                            ? moment(item?.saturdayOpenTime, "HH:mm").format("hh:mm A")
                            : "",
                        saturdayCloseTime: item?.isSaturdayOpen
                            ? moment(item?.saturdayCloseTime, "HH:mm").format("hh:mm A")
                            : "",
                        locationId: item?.locationId,
                    }));

                setAllLocationsOpeningHours(formattedHours);
            } catch (error) {
                console.error(error);
                setAllLocations([]);
                setAllLocationsOpeningHours([]);
            }

            setDataIsLoaded(true);
        };

        fetchData();
    }, []);

    return (
        <>
            <div className="mt-[14px] p-6">
                <div className="text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-800">
                        Our Locations
                    </h1>
                </div>

                {
                    dataIsLoaded
                        ? (
                            allLocationsOpeningHours?.length > 0
                                ? (
                                    <div className="max-w-6xl mx-auto p-4 grid gap-6 lg:grid-cols-3 content-center mt-12">
                                        {
                                            allLocations?.map((item: any, index: number) => {
                                                const openHour = allLocationsOpeningHours?.find((openHour: any) => openHour?.locationId === item?.id);

                                                return (
                                                    <div
                                                        key={index}
                                                        className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition duration-300"
                                                    >
                                                        <div className="bg-primary px-6 py-4">
                                                            <h2 className="text-lg font-semibold text-white">
                                                                {item?.locationName}
                                                            </h2>
                                                        </div>

                                                        <div className="p-6">
                                                            <p className="text-gray-500 text-sm mb-4 leading-relaxed">
                                                                {item?.street}, {item?.city}, {item?.state} {item?.zipCode}, {item?.country}
                                                            </p>

                                                            <div className="border-t border-gray-100 my-4" />

                                                            <div className="space-y-2">
                                                                {[
                                                                    { day: "Sunday", open: openHour?.sundayOpenTime, close: openHour?.sundayCloseTime },
                                                                    { day: "Monday", open: openHour?.mondayOpenTime, close: openHour?.mondayCloseTime },
                                                                    { day: "Tuesday", open: openHour?.tuesdayOpenTime, close: openHour?.tuesdayCloseTime },
                                                                    { day: "Wednesday", open: openHour?.wednesdayOpenTime, close: openHour?.wednesdayCloseTime },
                                                                    { day: "Thursday", open: openHour?.thursdayOpenTime, close: openHour?.thursdayCloseTime },
                                                                    { day: "Friday", open: openHour?.fridayOpenTime, close: openHour?.fridayCloseTime },
                                                                    { day: "Saturday", open: openHour?.saturdayOpenTime, close: openHour?.saturdayCloseTime },
                                                                ].map((d, i) => (
                                                                    <div key={i} className="flex justify-between text-sm">
                                                                        <span className="font-medium text-gray-700">
                                                                            {d.day}
                                                                        </span>

                                                                        {!d.open && !d.close ? (
                                                                            <span className="text-red-500 font-medium">
                                                                                Closed
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-gray-600">
                                                                                {d.open} - {d.close}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : (
                                    <div className="h-[calc(100vh-220px)] px-[1rem] py-[0.5rem] my-[1.5rem]">
                                        <div className="bg-white w-full h-full rounded-lg"                              >
                                            <div className="h-full flex items-center justify-center gap-x-[2rem] px-[2rem] py-[1rem] min-h-[24rem]">
                                                <p className="text-sm text-gray-400">No opening hours available.</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                        ) : (
                            <div className="h-[calc(100vh-220px)] px-[1rem] py-[0.5rem] my-[1.5rem]">
                                <div className="bg-white w-full h-full rounded-lg"                              >
                                    <div className="h-full flex items-center justify-center gap-x-[2rem] px-[2rem] py-[1rem] min-h-[24rem]">
                                        <p className="text-sm text-gray-400">Loading...</p>
                                    </div>
                                </div>
                            </div>
                        )
                }
            </div>

            <div className="mt-16">
                <h2 className="text-3xl font-bold text-center mb-6">
                    Our Locations on Map
                </h2>

                <div className="w-full overflow-hidden rounded-xl shadow-lg">
                    {allLocations.length === 0 ? (
                        <p className="text-center p-6">No active locations found.</p>
                    ) : (
                        <div style={{ height: "600px", width: "100%" }}>
                            <MapContainer
                                center={center}
                                zoom={10}
                                style={{ height: "100%", width: "100%" }}
                            >
                                <TileLayer
                                    attribution="© OpenStreetMap contributors"
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />

                                {allLocations.map((loc: any, index: number) => (
                                    <Marker
                                        key={index}
                                        position={[loc.latitude, loc.longitude] as LatLngExpression}
                                        icon={primaryPin}
                                    >
                                        <Popup>
                                            <strong>{loc.locationName}</strong> <br />

                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                                    `${loc.street}, ${loc.city}, ${loc.state} ${loc.zipCode}`
                                                )}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "#EA8616",
                                                    textDecoration: "underline",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {loc.street}, {loc.city}, {loc.state} {loc.zipCode}
                                            </a>

                                            <br />
                                            📞 {loc.phoneNumber} <br />
                                            ✉️ {loc.emailAddress}
                                        </Popup>
                                    </Marker>
                                ))}
                            </MapContainer>
                        </div>
                    )}
                </div>
            </div>
        </>

    )
}